(() => {
  const start = () => {
    const header = document.querySelector('.zekis-shop-header');
    const section = header?.closest('.shopify-section');
    if (!section || section.dataset.bitigSticky) return;
    section.dataset.bitigSticky = 'true';
    const measure = () => document.documentElement.style.setProperty('--bitig-header-height', `${Math.ceil(section.getBoundingClientRect().height)}px`);
    measure();
    new ResizeObserver(measure).observe(section);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
